const CATALOG_LEVEL_ORDER = {
  UG: 1,
  PG: 2,
  Diploma: 3
};

export function catalogLevels(levels) {
  return (levels || [])
    .filter((level) => CATALOG_LEVEL_ORDER[level.code])
    .sort(
      (a, b) => (CATALOG_LEVEL_ORDER[a.code] || 9) - (CATALOG_LEVEL_ORDER[b.code] || 9)
    );
}
